/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */



export function init() {
  const win = window as any;
  win.markerConfig = {
    project: '67bc563645298da2f76c6acc',
    source: 'snippet'
  };

  __run(window, document);
}



function __run(e: any, r: any) {
  if (!e.__Marker) {
    e.__Marker = {
    };
    const t: any[] = [];
    const n: any = {
      __cs: t
    };
    [
      'show',
      'hide',
      'isVisible',
      'capture',
      'cancelCapture',
      'unload',
      'reload',
      'isExtensionInstalled',
      'setReporter',
      'setCustomData',
      'on',
      'off'
    ].forEach(function (e) {
      n[e] = function () {
        const r = Array.prototype.slice.call(arguments);
        r.unshift(e), t.push(r);
      };
    }),
    (e.Marker = n);
    const s = r.createElement('script');
    (s.async = 1), (s.src = 'https://edge.marker.io/latest/shim.js');
    const i = r.getElementsByTagName('script')[0];
    i.parentNode.insertBefore(s, i);
  }
}
